import { IPromise } from 'angular';
import { IRawRole } from './role.interfaces';
import { ApiService } from '../api-service/api.service';
import { IDataMap } from '../../interfaces/data-map.interface';
import { UserRoles } from './role-statuses';

export interface IBaseRole {
  id: number;
  name: string;
}

export interface ISubRole {
  id: number;
  name: string;
  baseRoleId: number;
}

export class RoleService {
  static $inject = [
    'ApiService'
  ];
  roles: IRawRole[];
  baseRolesMap: IDataMap<IBaseRole>;
  subRolesMap: IDataMap<ISubRole>;

  constructor( private apiService: ApiService ) {
  }

  getRoles(): IPromise<IRawRole[]> {
    return this.apiService.get<any>('/pages/all/getAllRoles')
      .then(( data ) => {
        this.transformResponse(data.result);
        this.roles = data.result;
        return this.roles;
      });
  }

  isCandidate( role: number ): boolean {
    return !!this.subRolesMap && !!this.subRolesMap[ role ] && this.subRolesMap[ role ].baseRoleId === 2;
  }

  isEmployer( role: number ): boolean {
    return !!this.subRolesMap && !!this.subRolesMap[ role ] && this.subRolesMap[ role ].baseRoleId === 3;
  }

  isBusiness( role: number ): boolean {
    return !!this.subRolesMap && !!this.subRolesMap[ role ] && this.subRolesMap[ role ].baseRoleId === 1;
  }

  isOnshore( role: number ): boolean {
    return !!this.subRolesMap && !!this.subRolesMap[ role ] && this.subRolesMap[ role ].id === 21;
  }

  isSeafarer( role: number ): boolean {
    return !!this.subRolesMap && !!this.subRolesMap[ role ] && this.subRolesMap[ role ].id === 22;
  }

  isOilAndGas( role: number ): boolean {
    return !!this.subRolesMap && !!this.subRolesMap[ role ] && this.subRolesMap[ role ].id === 23;
  }

  getBaseRoleName( roleId: number ): string {
    const subRole = this.subRolesMap[ roleId ];
    if ( subRole ) {
      return this.baseRolesMap[ subRole.baseRoleId ]
        ? this.baseRolesMap[ subRole.baseRoleId ].name
        : '';
    } else {
      return '';
    }
  }

  getSubRoleName( roleId: number ): string {
    return this.subRolesMap[ roleId ]
      ? this.subRolesMap[ roleId ].name
      : '';
  }

  getRolesStatuses( role: number ): UserRoles {
    const userRoles = new UserRoles();
    userRoles.isCandidate = this.isCandidate(role);
    userRoles.isEmployer = this.isEmployer(role);
    userRoles.isBusiness = this.isBusiness(role);
    userRoles.isSeafarer = this.isSeafarer(role);
    userRoles.isOilAndGas = this.isOilAndGas(role);
    userRoles.isOnshore = this.isOnshore(role);
    return userRoles;
  }

  private transformResponse( data: IRawRole[] ) {
    this.baseRolesMap = {};
    this.subRolesMap = {};
    for ( const role of data ) {
      const baseRole = {
        id: Number(role.id),
        name: role.name
      };
      this.baseRolesMap[ baseRole.id ] = baseRole;
      for ( const subRole of role.sub_roles ) {
        const formattedSubrole = {
          id: Number(subRole.id),
          name: subRole.name,
          baseRoleId: baseRole.id
        };
        this.subRolesMap[ formattedSubrole.id ] = formattedSubrole;
      }
    }
  }


}



// WEBPACK FOOTER //
// ./app/core/services/role/role.service.ts